/**
 * EN/NO copy for the few words the first screens share. Screen-by-screen words live in
 * screenText.ts (English for now), the saboteur game in gameText.ts, scores in scoreText.ts.
 */
export const COPY = {
  en: {
    seat: 'SEAT',
    begin: 'BEGIN CHECK-IN',
    continue: 'CONTINUE',
  },
  no: {
    seat: 'SETE',
    begin: 'START INNSJEKK',
    continue: 'FORTSETT',
  },
} as const;

export type Lang = keyof typeof COPY;

/** Widened: every language supplies the same keys, with its own strings. */
export type Copy = { [K in keyof (typeof COPY)['en']]: string };
